enum COOKIES {
  'impersonatorLocale' = 'impersonatorLocale',
}

export { COOKIES }
